import { StyleSheet } from 'aphrodite/no-important';

export const wrapper = StyleSheet.create({
  95: {
    maxWidth: '95%'
  },
  90: {
    maxWidth: '90%'
  },
  85: {
    maxWidth: '80%'
  }
});
